export const ADD_USER_REQUEST = "@@addUserReducer/ADD_USER_REQUEST";
export const ADD_USER_SUCCESS = "@@addUserReducer/ADD_USER_SUCCESS";
export const ADD_USER_FAIL = "@@addUserReducer/ADD_USER_FAIL";